//
import { mapActions, mapGetters, mapState } from 'vuex'

//
import { RAppDrawer } from '@/components/reusable_components/drawers'
import { RAppToolbar } from '@/components/reusable_components/toolbars'
import RAuthBox from '@/components/reusable_components/SessionBox/SessionBox'
import SnackbarModal from '@/components/reusable_components/SnackbarModal/SnackbarModal'
import CriticalStockBox from '@/components/reusable_components/CriticalStockBox/CriticalStockBox'
import WhDetailProductCriticalNotifMdl from '@/models/Warehouse/WhDetailProductCriticalNotif'

//
import { getAndSaveLoginToken } from '@/services/auth/AuthService'

//
export default {
    name: 'app-component',
    components: {
        RAppDrawer,
        RAppToolbar,
        RAuthBox,
        SnackbarModal,
        CriticalStockBox,
    },
    computed: {
        //
        ...mapGetters('AuthModule', ['isAuthenticated']),

        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('MenuesModule', ['menues', 'titleTopBar', 'items']),

        /**
         *
         */
        authProps() {
            return {
                colorIconBtn: 'success',
                infoSession: {
                    title: this.user
                        ? [
                              this.user.hr_employee.names,
                              this.user.hr_employee.last_name1,
                          ].join(' ')
                        : '',
                    subtitle: [
                        'Sucursal: ' +
                            (this.user
                                ? this.user.hr_employee.g_branch_office.name
                                : ''),
                    ],
                },
            }
        },

        /**
         *
         */
        drawerProps() {
            return {
                items: this.menuItemsMapped,
            }
        },

        /**
         *
         */
        menuItemsMapped() {
            return [...(this.menues || [])].map(this.mapMenu)
        },

        /**
         *
         */
        toolbarProps() {
            return {
                title: this.titleTopBar,
                withScroll: !this.drawer,
            }
        },
    },
    data() {
        return {
            drawer: false,
            model: WhDetailProductCriticalNotifMdl,
        }
    },
    methods: {
        //
        ...mapActions('AuthModule', {
            authLogout: 'logoutRequestAction',
            goToMenu: 'goToMenu',
        }),

        //
        ...mapActions('MenuesModule', {
            fetchMenues: 'fetchMenues',
            setItemsTopBar: 'setItemsTopBar',
        }),

        //
        ...mapActions('SnackbarModal', {
            setSnackbar: 'setSnackbar',
        }),

        /**
         * show error fetch user toast
         */
        error() {
            //this.$toast.error( "Error al obtener el usuario." )
        },

        /**
         * fetch current user by token in route params
         */
        fetch() {
            getAndSaveLoginToken() //.then( this.success ).catch( this.error )
        },

        /**
         *
         */
        mapMenu(item) {
            return {
                icon: this.menuIcons[item.name] || item.icon,
                href: item.route,
                text: item.name,
                data: [...(item.g_submenus || [])].map(this.mapMenu),
            }
        },

        /**
         * show success fetch user toast
         */
        success() {
            //this.$toast.success( "Bienvenido." )
        },

        /**
         *
         */
        toggleDrawer() {
            this.drawer = !this.drawer
        },
        /*
         */
        logout: function() {
            event.preventDefault()
            this.authLogout()
                .then(() => {
                    this.$router.push('/login')
                })
                .catch(() => {
                    this.$router.push('/login')
                })
        },
        toMenu: async function() {
            event.preventDefault()
            await this.goToMenu()
        },
    },
    watch: {
        /**
         *
         */
        $route() {
            this.drawer = false
            this.setItemsTopBar([])
        },
    },
    created() {
        //
        this.menuIcons = {
            Abastecimiento: 'local_shipping',
            Bodegas: 'store',
            Despacho: 'departure_board',
            Inventario: 'assignment',
            Productos: 'category',
            Venta: 'storefront',
        }

        // verify if has login user
        if (this.isAuthenticated) {
            // show a welcome message
            //this.$toast.success( "Bienvenido." )
        } else {
            // show requesting message
            //this.$toast.info( "Consultando datos..." )

            // fetch user by param token
            this.fetch()
        }

        //
        this.fetchMenues(1)
    },
}
